import theme from "src/app/theme";

export const drawerWidth = theme.spacing(29);
